function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class MediaQueryObserver {
    listen() {
        this.isListening = true;
        if (this.supportsAddEventListener) {
            var _this_mediaQueryList_addEventListener, _this_mediaQueryList;
            (_this_mediaQueryList_addEventListener = (_this_mediaQueryList = this.mediaQueryList).addEventListener) === null || _this_mediaQueryList_addEventListener === void 0 ? void 0 : _this_mediaQueryList_addEventListener.call(_this_mediaQueryList, 'change', this.handleChange);
        } else if (this.supportsAddListener) {
            var _this_mediaQueryList_addListener, _this_mediaQueryList1;
            (_this_mediaQueryList_addListener = (_this_mediaQueryList1 = this.mediaQueryList).addListener) === null || _this_mediaQueryList_addListener === void 0 ? void 0 : _this_mediaQueryList_addListener.call(_this_mediaQueryList1, this.handleChange);
        }
    }
    unlisten() {
        this.isListening = false;
        if (this.supportsAddEventListener) {
            var _this_mediaQueryList_removeEventListener, _this_mediaQueryList;
            (_this_mediaQueryList_removeEventListener = (_this_mediaQueryList = this.mediaQueryList).removeEventListener) === null || _this_mediaQueryList_removeEventListener === void 0 ? void 0 : _this_mediaQueryList_removeEventListener.call(_this_mediaQueryList, 'change', this.handleChange);
        } else if (this.supportsAddListener) {
            var _this_mediaQueryList_removeListener, _this_mediaQueryList1;
            (_this_mediaQueryList_removeListener = (_this_mediaQueryList1 = this.mediaQueryList).removeListener) === null || _this_mediaQueryList_removeListener === void 0 ? void 0 : _this_mediaQueryList_removeListener.call(_this_mediaQueryList1, this.handleChange);
        }
    }
    subscribe(listener) {
        if (!this.isListening) {
            this.listen();
        }
        this.subscribers.add(listener);
    }
    unsubscribe(listener) {
        this.subscribers.delete(listener);
        if (this.subscribers.size === 0) {
            this.unlisten();
            return true;
        }
        return false;
    }
    constructor(query){
        var _window;
        _define_property(this, "query", void 0);
        _define_property(this, "matches", void 0);
        _define_property(this, "subscribers", void 0);
        _define_property(this, "mediaQueryList", void 0);
        _define_property(this, "supportsAddEventListener", void 0);
        _define_property(this, "supportsAddListener", void 0);
        _define_property(this, "isListening", void 0);
        _define_property(this, "handleChange", (e)=>{
            this.matches = e.matches;
            this.subscribers.forEach((listener)=>listener(e));
        });
        this.query = query;
        this.subscribers = new Set();
        this.isListening = false;
        const supportsMatchMedia = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia) === 'function';
        this.mediaQueryList = supportsMatchMedia ? window.matchMedia(this.query) : {
            matches: false
        };
        this.matches = this.mediaQueryList.matches;
        this.supportsAddEventListener = typeof this.mediaQueryList.addEventListener === 'function';
        this.supportsAddListener = typeof this.mediaQueryList.addListener === 'function';
    }
}

//# sourceMappingURL=MediaQueryObserver.js.map